import type { CourseInstructorDto } from "@artha/api-contracts";
import { COURSE_PEOPLE } from "./course-people.constants";

export function courseInitials(name: string): string {
  return name
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, COURSE_PEOPLE.initialsLength)
    .map((part) => Array.from(part)[0])
    .join("")
    .toLocaleUpperCase();
}

export function courseInstructors(
  people: CourseInstructorDto[] | undefined,
  legacyName: string,
): CourseInstructorDto[] {
  return people?.length
    ? people
    : legacyName
        .split(",")
        .map((name) => name.trim())
        .filter(Boolean)
        .map((name) => ({
          name,
          image_url: "",
          role: "",
          company: "",
          bio: "",
        }));
}
